import { OpenInNew } from '@mui/icons-material'
import { Box, Stack, Typography } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { observer } from 'mobx-react-lite'
import { FC } from 'react'
import { useMinimalsTheme } from '../../../hooks'

type Props = {
  title?: string | null
  reference: string
  infoText?: string | null
  onPrimaryAction?: () => void
}

export const ReferenceWidget: FC<Props> = observer((props: Props) => {
  const { title, reference, infoText, onPrimaryAction } = props
  const theme = useMinimalsTheme()
  const { t } = useTranslate()

  return (
    <Box sx={{ bgcolor: theme.palette.background.neutral, p: 2, borderRadius: 1 }}>
      <Stack direction='row' justifyContent='space-between' alignItems='center' spacing={2}>
        <Stack>
          <Typography variant='body2'>{title}</Typography>
          <Typography variant='subtitle1'>{reference}</Typography>
          <Typography variant='caption'>{infoText}</Typography>
        </Stack>
        <Stack>
          <Typography variant='subtitle1'>
            <Stack
              direction='row'
              alignItems='center'
              gap={theme.customSpacing.xs}
              onClick={onPrimaryAction}
              sx={{ cursor: 'pointer' }}
            >
              {t('view', 'View')} <OpenInNew />
            </Stack>
          </Typography>
        </Stack>
      </Stack>
    </Box>
  )
})
